var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',{ref:"header",staticClass:"header"},[_c('app-warn',{on:{"isWarn":_vm.isWarn}}),_vm._v(" "),_c('app-tip'),_vm._v(" "),_c('app-top'),_vm._v(" "),_c('app-navBar')],1),_vm._v(" "),_c('div',{ref:"none",staticClass:"none"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89ef4256","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Header.vue
// module id = null
// module chunks = 